export default __webpack_public_path__ + "static/topic11-92b98e6f3e5fa2e8ddf104f6d0ee7765.png";